/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  OtcOrdersFeature,
  OtcOrdersFeatureInterface,
} from "../OtcOrdersFeature";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "zeroExAddress",
        type: "address",
      },
      {
        internalType: "contract IEtherTokenV06",
        name: "weth",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "taker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "makerToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "takerToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "makerTokenFilledAmount",
        type: "uint128",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "takerTokenFilledAmount",
        type: "uint128",
      },
    ],
    name: "OtcOrderFilled",
    type: "event",
  },
  {
    inputs: [],
    name: "EIP712_DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "FEATURE_NAME",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "FEATURE_VERSION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "txOrigin",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiryAndNonce",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.OtcOrder",
        name: "order",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum LibSignature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct LibSignature.Signature",
        name: "makerSignature",
        type: "tuple",
      },
      {
        internalType: "uint128",
        name: "takerTokenFillAmount",
        type: "uint128",
      },
      {
        internalType: "address",
        name: "taker",
        type: "address",
      },
      {
        internalType: "bool",
        name: "useSelfBalance",
        type: "bool",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "_fillOtcOrder",
    outputs: [
      {
        internalType: "uint128",
        name: "takerTokenFilledAmount",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "makerTokenFilledAmount",
        type: "uint128",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "txOrigin",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiryAndNonce",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.OtcOrder[]",
        name: "orders",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "enum LibSignature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct LibSignature.Signature[]",
        name: "makerSignatures",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "enum LibSignature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct LibSignature.Signature[]",
        name: "takerSignatures",
        type: "tuple[]",
      },
      {
        internalType: "bool[]",
        name: "unwrapWeth",
        type: "bool[]",
      },
    ],
    name: "batchFillTakerSignedOtcOrders",
    outputs: [
      {
        internalType: "bool[]",
        name: "successes",
        type: "bool[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "txOrigin",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiryAndNonce",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.OtcOrder",
        name: "order",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum LibSignature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct LibSignature.Signature",
        name: "makerSignature",
        type: "tuple",
      },
      {
        internalType: "uint128",
        name: "takerTokenFillAmount",
        type: "uint128",
      },
    ],
    name: "fillOtcOrder",
    outputs: [
      {
        internalType: "uint128",
        name: "takerTokenFilledAmount",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "makerTokenFilledAmount",
        type: "uint128",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "txOrigin",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiryAndNonce",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.OtcOrder",
        name: "order",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum LibSignature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct LibSignature.Signature",
        name: "makerSignature",
        type: "tuple",
      },
      {
        internalType: "uint128",
        name: "takerTokenFillAmount",
        type: "uint128",
      },
    ],
    name: "fillOtcOrderForEth",
    outputs: [
      {
        internalType: "uint128",
        name: "takerTokenFilledAmount",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "makerTokenFilledAmount",
        type: "uint128",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "txOrigin",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiryAndNonce",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.OtcOrder",
        name: "order",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum LibSignature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct LibSignature.Signature",
        name: "makerSignature",
        type: "tuple",
      },
    ],
    name: "fillOtcOrderWithEth",
    outputs: [
      {
        internalType: "uint128",
        name: "takerTokenFilledAmount",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "makerTokenFilledAmount",
        type: "uint128",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "txOrigin",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiryAndNonce",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.OtcOrder",
        name: "order",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum LibSignature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct LibSignature.Signature",
        name: "makerSignature",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum LibSignature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct LibSignature.Signature",
        name: "takerSignature",
        type: "tuple",
      },
    ],
    name: "fillTakerSignedOtcOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "txOrigin",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiryAndNonce",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.OtcOrder",
        name: "order",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum LibSignature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct LibSignature.Signature",
        name: "makerSignature",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum LibSignature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct LibSignature.Signature",
        name: "takerSignature",
        type: "tuple",
      },
    ],
    name: "fillTakerSignedOtcOrderForEth",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "txOrigin",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiryAndNonce",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.OtcOrder",
        name: "order",
        type: "tuple",
      },
    ],
    name: "getOtcOrderHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "txOrigin",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiryAndNonce",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.OtcOrder",
        name: "order",
        type: "tuple",
      },
    ],
    name: "getOtcOrderInfo",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "orderHash",
            type: "bytes32",
          },
          {
            internalType: "enum LibNativeOrder.OrderStatus",
            name: "status",
            type: "uint8",
          },
        ],
        internalType: "struct LibNativeOrder.OtcOrderInfo",
        name: "orderInfo",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "txOrigin",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "nonceBucket",
        type: "uint64",
      },
    ],
    name: "lastOtcTxOriginNonce",
    outputs: [
      {
        internalType: "uint128",
        name: "lastNonce",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "migrate",
    outputs: [
      {
        internalType: "bytes4",
        name: "success",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class OtcOrdersFeature__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    zeroExAddress: string,
    weth: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<OtcOrdersFeature> {
    return super.deploy(
      zeroExAddress,
      weth,
      overrides || {}
    ) as Promise<OtcOrdersFeature>;
  }
  getDeployTransaction(
    zeroExAddress: string,
    weth: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(zeroExAddress, weth, overrides || {});
  }
  attach(address: string): OtcOrdersFeature {
    return super.attach(address) as OtcOrdersFeature;
  }
  connect(signer: Signer): OtcOrdersFeature__factory {
    return super.connect(signer) as OtcOrdersFeature__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): OtcOrdersFeatureInterface {
    return new utils.Interface(_abi) as OtcOrdersFeatureInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OtcOrdersFeature {
    return new Contract(address, _abi, signerOrProvider) as OtcOrdersFeature;
  }
}
